import React, { useMemo, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { ExpandMoreIcon } from './Icons';
import { Radio, Dropdown, Menu } from 'antd';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const RadioDropdown = ({
  className = '',
  overlayClassName = '',
  open = false,
  onClick = () => {},
  disabled = false,
  menuItems = [],
  selectedKeys = [],
  handleChange = () => {},
  menuProps = {},
  children,
}) => {
  const trans = useSelector(translator);
  const [isVisible, setIsVisible] = useState(open);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsVisible(false);
        onClick(event);
      }
    };

    if (isVisible) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isVisible, onClick]);

  const selectedLabel = useMemo(() => {
    if (!selectedKeys.length) return trans('SELECTFROMOPTIONS');

    const selection = menuItems.filter((item) => selectedKeys.includes(item.key));
    const separator = selection.length > 1 ? ', ' : '';
    return selection.map((item) => item.rawLabel || item.label).join(separator);
  }, [selectedKeys, menuItems, trans]);

  const handleDropdownClick = () => {
    if (!disabled) setIsVisible((prev) => !prev);
  };

  const renderMenu = (
    <Menu>
      {menuItems.map((item) => (
        <Menu.Item
          key={item.key}
          className={selectedKeys.includes(item.key) ? 'highlight-label' : ''}
          onClick={() => handleChange(item.key)}
        >
          <Radio checked={selectedKeys.includes(item.key)}>
            <span onClick={(e) => e.stopPropagation()}>{item.renderLabel || item.label}</span>
          </Radio>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown
      overlay={renderMenu}
      overlayClassName={`custom-dropdown-style ${overlayClassName}`}
      open={isVisible}
      disabled={disabled}
      {...menuProps}
    >
      <div
        ref={dropdownRef}
        className={`custom-dropdown ${className} ${disabled ? 'disabled' : ''}`}
        onClick={handleDropdownClick}
      >
        <div className="dropdown-label">
          {children || (
            <span className="text" title={selectedLabel}>
              {selectedLabel}
            </span>
          )}
        </div>
        <ExpandMoreIcon className={`status-icon ${isVisible ? 'rotate-180' : ''}`} />
      </div>
    </Dropdown>
  );
};

RadioDropdown.propTypes = {
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  open: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string,
      rawLabel: PropTypes.string,
      renderLabel: PropTypes.node,
    })
  ),
  selectedKeys: PropTypes.arrayOf(PropTypes.string),
  handleChange: PropTypes.func,
  menuProps: PropTypes.object,
  children: PropTypes.node,
};

export default RadioDropdown;
